import { CidadeDto } from './cidade.dto';

export class CidadeDetalhesDto extends CidadeDto {
  centro: number[];
}
